// src/components/SetupWizard/Review.js

import React from 'react';
import PropTypes from 'prop-types';

const Review = ({ formData, onBack, onSubmit, error }) => (
  <div className="p-6 space-y-6">
    <div>
      <h2 className="text-xl font-bold mb-6">Review & Confirm</h2>
    </div>
    <div className="space-y-4">
      <div className="space-y-4">
        {/* Basic Information Section */}
        <div>
          <h3 className="font-semibold">Basic Information</h3>
          <p>Company Name: {formData.company_name}</p>
          <p>Domain: {formData.primary_domain}</p>
          {formData.tagline && <p>Tagline: {formData.tagline}</p>}
        </div>

        {/* Visuals & Theme Section */}
        <div>
          <h3 className="font-semibold">Visuals & Theme</h3>
          <p>Logo URL: {formData.logo_url || 'Not set'}</p>
          <p>Background URL: {formData.background_url || 'Not set'}</p>
          <div className="flex space-x-4 mt-2">
            <div className="flex items-center">
              <span>Primary Color:</span>
              <div
                className="w-6 h-6 inline-block ml-2 rounded border"
                style={{ backgroundColor: formData.primary_color }}
              ></div>
            </div>
            <div className="flex items-center">
              <span>Secondary Color:</span>
              <div
                className="w-6 h-6 inline-block ml-2 rounded border"
                style={{ backgroundColor: formData.secondary_color }}
              ></div>
            </div>
          </div>
        </div>

        {/* App Configuration Section */}
        <div>
          <h3 className="font-semibold">App Configuration</h3>
          <p>API Base URL: {formData.api_base_url}</p>
          <p>Default Locale: {formData.default_locale}</p>
          <p>Support Email: {formData.support_email}</p>
        </div>
      </div>

      {/* Error Display */}
      {error && (
        <div className="p-4 bg-red-50 border border-red-200 rounded text-red-800">
          <p className="font-medium">Configuration validation failed:</p>
          {error.details ? (
            <ul className="mt-2 list-disc pl-5">
              {error.details.map((detail, index) => (
                <li key={index}>
                  {detail.loc?.[1]}: {detail.msg}
                </li>
              ))}
            </ul>
          ) : (
            <p>{error.message}</p>
          )}
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex space-x-4">
        <button
          onClick={onBack}
          className="flex-1 p-2 border rounded hover:bg-gray-100"
        >
          Back
        </button>
        <button
          onClick={onSubmit}
          className="flex-1 p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Confirm & Save
        </button>
      </div>
    </div>
  </div>
);

// PropTypes for type checking
Review.propTypes = {
  formData: PropTypes.shape({
    company_name: PropTypes.string.isRequired,
    primary_domain: PropTypes.string.isRequired,
    tagline: PropTypes.string,
    logo_url: PropTypes.string,
    background_url: PropTypes.string,
    primary_color: PropTypes.string.isRequired,
    secondary_color: PropTypes.string.isRequired,
    api_base_url: PropTypes.string.isRequired,
    default_locale: PropTypes.string.isRequired,
    support_email: PropTypes.string.isRequired,
  }).isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.shape({
    message: PropTypes.string,
    details: PropTypes.arrayOf(
      PropTypes.shape({
        loc: PropTypes.array,
        msg: PropTypes.string,
      })
    ),
  }),
};

export default Review;
